import { createUseStyles } from 'react-jss'
import ContentLimits from '../../../styles/ContentLimits'
import MediaQueries from '../../../styles/MediaQueries'

export interface StyleProps {
  backgroundImageUrl?: string
}

const useStyles = createUseStyles({
  contentColumnsBackground: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    padding: '50px 25px'
  },

  contentColumns: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },

  column: {
    '&:not(:last-child)': {
      marginTop: '25px'
    },
    display: 'flex',
    alignContent: 'center',
    flex: 1,
    flexBasis: 0
  },

  rise: {
    order: -1
  },

  image: {
    width: '100%'
  },

  paragraph: {
    padding: '0px'
  },

  [MediaQueries.Tablet]: {
    rise: {
      order: 0
    },
    contentColumnsBackground: {
      padding: '65px 0px',
      alignItems: 'center'
    },
    column: {
      '&:not(:last-child)': {
        marginTop: '0px',
        marginRight: '50px'
      }
    },
    contentColumns: {
      flexDirection: 'row',
      maxWidth: ContentLimits[MediaQueries.Tablet]
    }
  },

  [MediaQueries.LaptopSmall]: {
    contentColumnsBackground: {
      padding: '60px 0px'
    },
    column: {
      '&:not(:last-child)': {
        marginRight: '80px'
      }
    },
    contentColumns: {
      maxWidth: ContentLimits[MediaQueries.LaptopSmall]
    }
  },

  [MediaQueries.LaptopLarge]: {
    contentColumnsBackground: {
      padding: '110px 0px'
    },
    column: {
      '&:not(:last-child)': {
        marginRight: '80px'
      }
    },
    contentColumns: {
      maxWidth: ContentLimits[MediaQueries.LaptopLarge]
    }
  }
})

export default useStyles
